/**
 * @returns {React.ReactElement}
 */
const FSEBarsLogo = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 180 180"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_28_563)">
      <path
        d="M25.3456 48.6C16.1859 48.6 9 56.5818 9 65.7364V78.3091C9.01819 81.4545 12.1927 83.6455 15.1034 82.4545C18.8237 80.9455 19.4332 80.2455 25.3456 80.2455H119.699C129.768 80.2455 137.927 71.9909 137.927 61.9364V55.9636C137.927 51.9182 134.635 48.6 130.587 48.6H25.3456ZM25.3456 0C16.1859 0 9 7.98182 9 17.1364V29.7091C9.01819 32.8545 12.1927 35.0455 15.1034 33.8545C18.8237 32.3455 19.4332 31.6455 25.3456 31.6455H151.926C161.995 31.6455 170.155 23.3909 170.155 13.3364V7.36364C170.155 3.31818 166.862 0 162.814 0H25.3365L25.3456 0ZM25.3456 145.8C16.1859 145.8 9 153.782 9 162.936V175.509C9.01819 178.655 12.1927 180.845 15.1034 179.655C18.8237 178.145 19.4332 177.445 25.3456 177.445H55.2352C65.3045 177.445 73.4637 169.191 73.4637 159.136V153.164C73.4637 149.118 70.1709 145.8 66.1232 145.8H25.3365H25.3456ZM25.3456 97.2C16.1859 97.2 9 105.182 9 114.336V126.909C9.01819 130.055 12.1927 132.245 15.1034 131.055C18.8237 129.545 19.4332 128.845 25.3456 128.845H87.4716C97.5409 128.845 105.7 120.591 105.7 110.536V104.564C105.7 100.518 102.407 97.2 98.3595 97.2H25.3456Z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="clip0_28_563">
        <rect width="161" height="180" fill="white" transform="translate(9)" />
      </clipPath>
    </defs>
  </svg>
);

export default FSEBarsLogo;
